import { translationConstants } from "./translation.constants";

export const competitionConstants = {
  COMPETITION_DATA: "COMPETITION_DATA",
  MY_COMPETITION_DATA: "MY_COMPETITION_DATA",
  COMPETITION_PUBLIC_DATA: "COMPETITION_PUBLIC_DATA",
  COMPETITION_DATA_ID: "COMPETITION_DATA_ID",
  COMPETITION_PUBLIC_DATA_ID: "COMPETITION_PUBLIC_DATA_ID",
  ADD_COMPETITION: "ADD_COMPETITION",
  VIEW_ADD_COMPETITION: "VIEW_ADD_COMPETITION",
  DELETE_COMPETITION: "DELETE_COMPETITION",
  ADD_COMPETITION_PARTICIPANT: "ADD_COMPETITION_PARTICIPANT",
  VALIDATE_PARTICIPANTS_COMPETITION: "VALIDATE_PARTICIPANTS_COMPETITION",
  VALIDATE_PARTICIPANTS_FALSE: "VALIDATE_PARTICIPANTS_FALSE",
  CANCEL_PUBLIC_REGISRATION: "CANCEL_PUBLIC_REGISRATION",
  CANCEL_PRIVATE_REGISRATION: "CANCEL_PRIVATE_REGISRATION",
  COMPETITION_MODAL: "COMPETITION_MODAL",
  GET_COMPETITION_GENERAL_DATA: "GET_COMPETITION_GENERAL_DATA",
  GET_COMPETITION_PARTICIPANTS_DATA: "GET_COMPETITION_PARTICIPANTS_DATA",
  GET_COMPETITION_STATS: "GET_COMPETITION_STATS",
  GET_COMPETITION_FEEDBACK_QUESTION: "GET_COMPETITION_FEEDBACK_QUESTION",
  SAVE_COMPETITION_FEEDBACK: "SAVE_COMPETITION_FEEDBACK",
  GET_COMPETITION_FEEDBACK: "GET_COMPETITION_FEEDBACK",
  GET_COMPETITION_DETAIL_RESULT: "GET_COMPETITION_DETAIL_RESULT",
  GET_COMPETITION_PARTICIPANTS_BY_EMAIL:
    "GET_COMPETITION_PARTICIPANTS_BY_EMAIL",
  DOWNLOAD_LIST: "DOWNLOAD_LIST",
  COMPETITION_PARTICIPANTS_BY_EMAIL_NULL:
    "COMPETITION_PARTICIPANTS_BY_EMAIL_NULL",
  COMPETITION_TOTAL_PAYMENT_BY_ID_DATA: "COMPETITION_TOTAL_PAYMENT_BY_ID_DATA",
  COMP_LEADERBOARD_BOAT_CLASSES: "COMP_LEADERBOARD_BOAT_CLASSES",

  GET_UPLOADED_FILE: "GET_UPLOADED_FILE",

  PUBLISH_BUTTON: "PUBLISH_BUTTON",
  UNPUBLISH_BUTTON: "UNPUBLISH_BUTTON",
  UPDATE_BUTTON: "UPDATE_BUTTON",
  DRAFT_BUTTON: "DRAFT_BUTTON",
  ADD_BUTTON: "ADD_BUTTON",
  RANKING: "RANKING",
  POINTS: "POINTS",

  PUBLIC: "Public",
  PRIVATE: "Private",
  ALL: "All",
  UPCOMING: "upcoming",
  PREVIOUS: "previous",

  VERIFIED_USER: "VERIFIED_USER",
  PRACTITIONER: "PRACTITIONER",
};

export const competitionProvidedServices = {
  LEAVE_LETTER: "LEAVE_LETTER",
  MEALS: "MEALS",
  FLIGHTS: "FLIGHTS",
  RENTED_BOATS: "RENTED_BOATS",
  ACCOMMODATION: "ACCOMMODATION",
  SNACKS_AND_WATER: "SNACKS_AND_WATER",
  BOATS_FOR_PARTICIPANTS: "BOATS_FOR_PARTICIPANTS",
};

export const competitionsStatusEnum = {
  PUBLISHED: 0,
  UNPUBLISHED: 1,
  DRAFT: 2,
  EXPIRED: 3,
};

export const competitionParticipantStatus = {
  APPROVED: 0,
};

export const refreshDispatch = {
  MY_COMPETITION: "MY_COMPETITION",
  PARTICIPANT_ADMIN: "PARTICIPANT_ADMIN",
};

export const competitionAllowedUsers = (t) => [
  {
    label: t(translationConstants.VERIFIED_USER),
    value: competitionConstants.VERIFIED_USER,
  },
  {
    label: t(translationConstants.SAILOR),
    value: competitionConstants.PRACTITIONER,
  },
];
